import React from 'react';

import { MobileSummaryDetails } from '@src/features/cart';

import type { UseSaleChangeSummaryResult } from '../hooks/useSaleChangeSummary';
import { SaleChangeSummaryTotal } from './SaleChangeSummaryTotal';

type SaleChangeSummaryDetailsProps = Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> & {
  summary: UseSaleChangeSummaryResult;
};

export const SaleChangeSummaryDetails = (props: SaleChangeSummaryDetailsProps) => {
  const { summary, ...rest } = props;

  if (!summary.hasComparison) {
    return null;
  }

  return (
    <MobileSummaryDetails data-testid='checkout-mobile-sale-change-summary-details' {...rest}>
      <SaleChangeSummaryTotal summary={summary} showTotal={false} />
    </MobileSummaryDetails>
  );
};

export default SaleChangeSummaryDetails;
